import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { passwordValidator } from "../../../../shared/utils/helpers/common.helper";
import { UserService } from "../../users/user.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  passwordForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    public location: Location,
    private userService: UserService,
    private notificationService: NotificationService,
    public router: Router,
  ) {}

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group(
      {
        oldPassword: ["", [Validators.required, Validators.minLength(5)]],
        newPassword: ["", [Validators.required, Validators.minLength(5)]],
        confirmPassword: ["", [Validators.required]],
      },
      { validators: passwordValidator("newPassword", "confirmPassword") },
    );
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(): void {
    if (this.passwordForm.invalid) {
      return;
    }
    const { oldPassword, newPassword } = this.passwordForm.value;
    this.userService.changePassword({ oldPassword, newPassword }).subscribe(
      () => {
        this.notificationService.success("Password has been changed");
        this.passwordForm.reset();
        this.router.navigate(["/login"]);
      },
      (err) => {
        const error = `There was an error changing the password:\n ${err}`;
        this.notificationService.error(error);
      },
    );
  }
}
